define('lib/pager/view/PagerView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    return LayoutView.extend({

        template: '#pager_view',
        _pager: null,

        initialize: function () {
            this._pager = this.getOption('pager');
            this.listenTo(this._pager, 'update:info', this.render);
        },

        serializeData: function () {
            var page = this._pager.getPage();
            var nextPage = null;
            var prevPage = null;
            if (page > 1) {
                prevPage = page - 1;
            }
            if (page < this._pager.getPagesCount()) {
                nextPage = page + 1;
            }

            return _.extend({
                url: this.getOption('url'),
                next_page: nextPage,
                prev_page: prevPage,
                show_count: this.getOption('showCount') && this._pager.getItemsCount()
            }, this._pager.getData());
        }

    });

});
